export const NO_MATCHES_FILTERS_TITLE = 'No matches for your filters :/';
export const NO_MATCHES_BODY =
    'Try adjusting your keywords or clearing your filters to see more projects.';

/**
 * Title for the Projects "no matches" zero-state (Figma 9750:36409).
 * Quotes the trimmed search term when there is one; otherwise the active
 * filters are what excluded everything, so say so instead of quoting "".
 */
export function getNoMatchesTitle(searchValue) {
    const term = typeof searchValue === 'string' ? searchValue.trim() : '';
    return term ? `No matches for "${term}" :/` : NO_MATCHES_FILTERS_TITLE;
}
